export default __webpack_public_path__ + "static/media/Flag_of_Kuwait.704653b0.svg";